import React from 'react';

// Styles & Assets
import styles from './VitalSignInput.module.css';

// Components
import Input from '../../UI/Input/Input';

// Hooks
import { useState } from 'react';

// Interfaces
import { Parameter } from '../../../interfaces/Profile';

// Languages
import { useTranslation } from 'react-i18next';

const VitalSignInput: React.FC<{
    param: Parameter,
    defaultNum: number | undefined | null,
    defaultComment: string | undefined | null,
    handleChange: (paramID: string, value?: number, comment?: string) => void,
}> = ({ param, defaultNum, defaultComment, handleChange }) => {

    const { t } = useTranslation();

    const [errorMsg, setErrorMsg] = useState<string | null>(null);

    const handleChangeNum = (evt: React.ChangeEvent<HTMLInputElement>) => {
        
        const num = (evt.target.value.trim() !== '') ?
            Number(evt.target.value) : NaN;
            
        if (param.max_anomally_limit !== null && param.max_anomally_limit !== undefined
            && num > param.max_anomally_limit) {
            setErrorMsg(t('value_smaller') + ' ' + param.max_anomally_limit +'.');
            return;
        }
        else if (param.min_anomally_limit !== null && param.min_anomally_limit !== undefined
            && num < param.min_anomally_limit) {
            setErrorMsg(t('value_higher') + ' ' + param.min_anomally_limit +'.');
            return;
        }
        else setErrorMsg(null);
        handleChange(param.id, num);
    };

    const handleChangeComment = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
        handleChange(param.id, undefined, evt.target.value);
    };

    return (
        <div className={styles.inputContainer}>
            <p className={styles.inputTitle}>{param.name}</p>
            <div className={styles.input}>
                <div className={styles.inputNumber}>
                    <Input
                        label=''
                        defaultValue={defaultNum || undefined}
                        onChange={handleChangeNum}
                        type='number'
                        error={errorMsg !== null}
                        errorMsg={errorMsg}
                    />
                </div>
                <textarea
                    className={styles.textArea}
                    placeholder={t('write_comment') as string}
                    defaultValue={defaultComment || ''}
                    onChange={handleChangeComment}
                ></textarea>
            </div>
        </div>
    );
};

export default VitalSignInput;